import { Component } from '@angular/core';
import { SkipConversationDetail__SkipEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Conversation Details__Skip') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skipconversationdetail__skip-form',
    templateUrl: './skipconversationdetail__skip.form.component.html'
})
export class SkipConversationDetail__SkipFormComponent extends BaseFormComponent {
    public record!: SkipConversationDetail__SkipEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'conversationDetailsSkip', sectionName: 'Conversation Details__Skip', isExpanded: false }
        ]);
    }
}

